<template>
  <v-snackbar
    class="common-snackbar"
    :color="color"
    :value="isSnackbarActive"
    multi-line
    :timeout="timeout"
    :style="cssVars"
  >
    <span @click="handlerClick" :class="{ clickable: handler }">{{
      text
    }}</span>
    <template v-slot:action="{ attrs }">
      <v-btn
        color="common-snackbar__button"
        style="background-color: transparent"
        depressed
        v-bind="attrs"
        @click="HIDE_SNACKBAR"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
    <div v-if="handler" class="snackbar-loader" />
  </v-snackbar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ModuleTypes } from "@/store/ModuleTypes";
import { SnackbarMutationTypes } from "@/views/academy/common/snackbar/SnackbarMutationTypes";

export default {
  name: "CommonSnackbar",
  computed: {
    ...mapGetters(ModuleTypes.SNACKBAR, [
      "isSnackbarActive",
      "text",
      "timeout",
      "handler",
      "color"
    ]),
    cssVars() {
      return {
        "--timeout": `${~~(this.timeout / 1000)}s`
      };
    }
  },

  methods: {
    ...mapActions(ModuleTypes.SNACKBAR, [SnackbarMutationTypes.HIDE_SNACKBAR]),
    handlerClick() {
      if (this.handler) {
        this.HIDE_SNACKBAR();
        this.handler();
      }
    }
  }
};
</script>

<style scoped>
.common-snackbar {
  display: flex;
  justify-content: flex-start;
  z-index: 99999 !important;
}

.clickable {
  cursor: pointer;
}

.v-snack__wrapper.v-sheet {
  margin: 40px !important;
}

.common-snackbar__button {
  width: 30px !important;
  height: 30px !important;
}

.snackbar-loader {
  position: absolute;
  background-color: beige;
  height: 1px;
  bottom: 1px;
  left: 1px;
  max-width: calc(100% - 2px);
  animation: load linear 1;
}

@keyframes load {
  0% {
    width: 0;
  }

  100% {
    width: 100%;
  }
}
</style>
